import React from 'react'
import {NavButtonProps} from 'Event/Dashboard/components/NavButton'
import {Controller, UseFormMethods} from 'react-hook-form'
import ImageAssetUploader from 'lib/asset/ImageAssetUploader'
import TextField from 'lib/ui/TextField'
import {defaultGeneratingCertificateText} from 'Event/Dashboard/components/NavButton/CertificateButton'

export default function CertificateGeneratingConfig(props: {
  watch: UseFormMethods['watch']
  register: UseFormMethods['register']
  control: UseFormMethods['control']
  button: NavButtonProps
  inputNamePrefix?: string
}) {
  const {control, button, watch, register, inputNamePrefix = ''} = props

  const hasImage = !!watch(`${inputNamePrefix}certificate.generatingImage`)

  return (
    <>
      <TextInput
        register={register}
        button={button}
        inputNamePrefix={inputNamePrefix}
        show={!hasImage}
      />
      <ImageInput
        control={control}
        button={button}
        inputNamePrefix={inputNamePrefix}
      />
    </>
  )
}

function TextInput(props: {
  register: UseFormMethods['register']
  button: NavButtonProps
  inputNamePrefix?: string
  show: boolean
}) {
  const {register, button, show, inputNamePrefix = ''} = props

  if (!show) {
    return null
  }

  return (
    <TextField
      defaultValue={
        button.certificate?.generatingText ?? defaultGeneratingCertificateText
      }
      name={`${inputNamePrefix}certificate.generatingText`}
      label="Generating Certificate Text"
      fullWidth
      inputProps={{
        'aria-label': 'set generating text',
        ref: register({required: 'Generating text is required'}),
      }}
    />
  )
}

function ImageInput(props: {
  control: UseFormMethods['control']
  button: NavButtonProps
  inputNamePrefix?: string
}) {
  const {control, button, inputNamePrefix = ''} = props

  return (
    <Controller
      name={`${inputNamePrefix}certificate.generatingImage`}
      control={control}
      defaultValue={button.certificate?.generatingImage ?? ''}
      render={({value, onChange}) => (
        <ImageAssetUploader
          onChange={onChange}
          value={value}
          alt="button image"
          uploadInputProps={{
            'aria-label': 'upload generating image',
          }}
          canResize
          disableAutoRemove
        />
      )}
    />
  )
}
